export default {
  hotArea: 'Hot area',
  hotIndustry: 'Hot industry',
  hotExhibition: 'Hot exhibition'
}
